import create from "zustand";
import { EdgeSystemState, EdgeSystemStatus, EdgeSystemType, SystemState } from "../types";
import { defaultSystemState } from "../utils";

export interface ISystemStateStore {
  systemState: SystemState;
  hasCompletedInitialSync: boolean;

  setHasSynced: () => void;
  setSystemState: (systemState: SystemState) => void;
  updateSystemState: (state: EdgeSystemState) => void;
}

export const useSystemStateStore = create<ISystemStateStore>((setState, getState) => ({
  systemState: defaultSystemState,
  hasCompletedInitialSync: false,

  setHasSynced: () => setState({ hasCompletedInitialSync: true }),
  setSystemState: (systemState: SystemState) => {
    const shouldSetHasSynced = systemState[EdgeSystemType.DataSync].status === EdgeSystemStatus.Success;
    const newHasSynced = getState().hasCompletedInitialSync || shouldSetHasSynced;

    setState({ systemState, hasCompletedInitialSync: newHasSynced });
  },
  updateSystemState: (state: EdgeSystemState) => {
    const prevSystemState = getState().systemState;
    const newSystemState = {
      ...prevSystemState,
      [state.systemType]: state
    };

    getState().setSystemState(newSystemState);
  },
}));